/**
 * 请求错误码对应的中英文本
 */
export default {
  dbl_error_1: '加载失败', // 兜底文本
  dbl_error_10013: '{name}错误：引用字段无效，Error 400：{msg}',
  dbl_error_53005: '数据集缺少用户属性，不支持用户筛选。',
};